export const calculateFormProgress = (studyData, formData) => {
    if (!studyData || !studyData.sections) return 0;

    let totalFields = 0;
    let filledFields = 0;

    studyData.sections.forEach(section => {
        section.questions.forEach(question => {
            if (question.type !== 'calculated') {
                totalFields++;
                const value = formData[question.id];

                if (value !== undefined && value !== null && value !== '') {
                    if (Array.isArray(value)) {
                        if (value.length > 0) filledFields++;
                    } else if (typeof value === 'string') {
                        if (value.trim() !== '') filledFields++;
                    } else {
                        filledFields++;
                    }
                }
            }
        });
    });

    return totalFields > 0 ? Math.round((filledFields / totalFields) * 100) : 0;
};

export const calculateSectionProgress = (totalSections, currentSectionIndex) => {
    return Math.round(((currentSectionIndex + 1) / totalSections) * 100);
};